import React, { useState, useEffect } from 'react';
import LayoutRow from './Partials/LayoutRow';
import PropTypes from 'prop-types';
import QvrfContainer from 'components/qvrf_component/QvrfContainer';
import ValpakRedirectButton from 'components/common/Qlik/ValpakRedirectButton';
import config from 'coeus.config';

const Page = ({ qsOptions, page }) => {
    const { contentRows } = page;
    if (!contentRows) {
        return '';
    }

    return (
        <div>
            <div className="u-m-xsmall u-mh-700">
                {config.page.valpak_sso.enabled && page.valpakSSO && (
                    <QvrfContainer config={qsOptions.config} loaderHeight={50}>
                        <ValpakRedirectButton
                            qsOptions={qsOptions}
                            buttonText={'VALPAK SSO'}
                        />
                    </QvrfContainer>
                )}
                <LayoutRow contentRows={contentRows} qsOptions={qsOptions} />
            </div>
        </div>
    );
};

Page.propTypes = {
    page: PropTypes.object.isRequired,
    qsOptions: PropTypes.object.isRequired,
};

export default Page;
